(function () {
  'use strict';

  function shopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    var willOpen = nav.hasAttribute('hidden');
    nav.toggleAttribute('hidden', !willOpen);
    toggle.setAttribute('aria-expanded', String(willOpen));
    var label = toggle.querySelector('[data-menu-toggle-label]');
    if (label) label.textContent = willOpen ? 'Close' : 'Menu';
    if (willOpen) {
      var firstLink = nav.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
      if (firstLink) firstLink.focus();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var nav = document.querySelector('[data-mobile-nav]');
    var toggle = document.querySelector('[data-menu-toggle]');
    if (!nav || nav.hasAttribute('hidden')) return;
    nav.setAttribute('hidden', '');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      var label = toggle.querySelector('[data-menu-toggle-label]');
      if (label) label.textContent = 'Menu';
      toggle.focus();
    }
  });

  async function refreshCartCount() {
    try {
      var response = await fetch(shopifyRoot() + 'cart.js', {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      var cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach(function (node) {
        node.textContent = cart.item_count;
      });
    } catch (_) {
      // Cart count refresh is optional after a successful add.
    }
  }

  function setQuickAddStatus(status, text, isError) {
    if (!status) return;
    status.textContent = text || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('.mw-quick-add-form');
    if (!form || typeof window.fetch !== 'function') return;

    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    var card = form.closest('.product-card');
    var status = card ? card.querySelector('[data-quick-add-status]') : form.querySelector('[data-quick-add-status]');
    var originalText = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
      button.textContent = 'Adding...';
    }
    setQuickAddStatus(status, '', false);

    try {
      var response = await fetch(shopifyRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      var payload = await response.json().catch(function () { return {}; });
      if (!response.ok) {
        var error = new Error(payload.description || payload.message || 'This item could not be added.');
        error.status = response.status;
        throw error;
      }

      await refreshCartCount();
      setQuickAddStatus(status, 'Added to bag.', false);
    } catch (error) {
      setQuickAddStatus(status, error.message || 'This item could not be added.', true);
      // A 422 response normally means inventory or variant availability changed.
      // Keep the attempted variant disabled so shoppers cannot repeatedly submit it.
      if (button && error.status === 422) {
        button.setAttribute('aria-disabled', 'true');
        button.dataset.inventoryUnavailable = 'true';
      }
    } finally {
      if (button) {
        var inventoryUnavailable = button.dataset.inventoryUnavailable === 'true';
        button.disabled = inventoryUnavailable;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        button.textContent = inventoryUnavailable ? 'Sold out' : originalText;
      }
    }
  });

  function formatVariantMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2);
    }
  }

  function initProduct(root) {
    if (!root || root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';

    var sectionId = root.getAttribute('data-section-id');
    var form = root.querySelector('#MarketWifeProductForm-' + sectionId);
    var variantIdInput = root.querySelector('[data-mw-variant-id]');
    var submit = root.querySelector('[data-mw-submit]');
    var message = root.querySelector('[data-mw-message]');
    var price = root.querySelector('[data-mw-price]');
    var compare = root.querySelector('[data-mw-compare]');
    var variantDataEl = document.getElementById('MarketWifeVariants-' + sectionId);
    if (!form || !variantIdInput || !variantDataEl) return;

    var variants;
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch (_) {
      return;
    }
    var currency = root.getAttribute('data-currency') || 'USD';
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('.mw-option-radio'));

    function selectedOptions() {
      var groups = root.querySelectorAll('.mw-product-option');
      return Array.prototype.map.call(groups, function (group) {
        var checked = group.querySelector('.mw-option-radio:checked');
        return checked ? checked.value : null;
      });
    }

    function exactVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === options[index];
        });
      });
    }

    function candidateAvailable(optionIndex, optionValue, current) {
      return variants.some(function (variant) {
        if (!variant.available || variant.options[optionIndex] !== optionValue) return false;
        return variant.options.every(function (value, index) {
          if (index === optionIndex) return true;
          return !current[index] || value === current[index];
        });
      });
    }

    function updateOptionAvailability(current) {
      optionInputs.forEach(function (input) {
        var optionIndex = parseInt(input.getAttribute('data-option-index'), 10);
        var possible = candidateAvailable(optionIndex, input.value, current);
        var label = root.querySelector('label[for="' + input.id + '"]');

        // Never silently change a shopper's selection. A checked value remains
        // selectable even when the full combination is sold out; the Add to Bag
        // button will clearly report the exact combination as sold out.
        input.disabled = !possible && !input.checked;
        input.setAttribute('aria-disabled', String(!possible && !input.checked));
        if (label) label.classList.toggle('is-unavailable', !possible && !input.checked);
      });
    }

    function setMessage(text) {
      if (!message) return;
      message.textContent = text || '';
      message.hidden = !text;
    }

    function updateVariant() {
      var options = selectedOptions();
      updateOptionAvailability(options);

      if (options.some(function (value) { return value === null; })) {
        variantIdInput.value = '';
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Choose options';
        }
        setMessage('Please choose an option.');
        return;
      }

      var match = exactVariant(options);
      if (!match) {
        variantIdInput.value = '';
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Unavailable';
        }
        setMessage('That option combination is unavailable. Please choose another.');
        return;
      }

      variantIdInput.value = match.id;
      if (price) price.textContent = formatVariantMoney(match.price, currency);

      if (compare) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compare.hidden = false;
          compare.textContent = formatVariantMoney(match.compare_at_price, currency);
        } else {
          compare.hidden = true;
          compare.textContent = '';
        }
      }

      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
      setMessage(match.available ? '' : 'This combination is sold out.');

      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        } catch (_) {
          // URL updates are non-essential to purchasing.
        }
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    updateVariant();
  }


  function focusServerFeedback() {
    var feedback = document.querySelector('.newsletter-form__status[tabindex="-1"], .mw-form-errors[tabindex="-1"]');
    if (feedback) feedback.focus();
  }

  function initProducts(scope) {
    (scope || document).querySelectorAll('[data-marketwife-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initProducts(document); focusServerFeedback(); });
  } else {
    initProducts(document);
    focusServerFeedback();
  }

  // Shopify's theme editor can reload a section without reloading the page.
  document.addEventListener('shopify:section:load', function (event) {
    initProducts(event.target);
  });
})();
